import InfoLine from './InfoLine';

export default InfoLine;
